import React, { useState } from "react"
import PropTypes from "prop-types";
import axios from "axios";

const downloadBlob = (blob, filename) => {
  // see https://stackoverflow.com/questions/41938718/how-to-download-files-using-axios
  const href = URL.createObjectURL(blob);

  const link = document.createElement('a');

  link.href = href;

  link.setAttribute('download', filename);

  document.body.appendChild(link);

  link.click();

  document.body.removeChild(link);

  URL.revokeObjectURL(href);
}

const GroupExportTool = ({ exportableGroups }) => {
  const [selectedGroupId, setSelectedGroupId] = useState(exportableGroups[0].id);

  const exportGroup = () => {
    axios.post(
      `/support/sso_audits/group_export?group_id=${selectedGroupId}`,
      {},
      { responseType: "blob" }
    ).then((response) => {
      const filename =
        response
        .headers
        .get("Content-Disposition")
        .split("; ")[1]
        .split("filename=")[1]
        .replace(/['"]/g, '');

      downloadBlob(response.data, filename);
    })
  }

  return (
    <div>
    <h4>Group Export</h4>
    <h6>Export A CSV with the header <tt>okta id,email,first name,last name,okta status</tt></h6>
      <select
        id="select-group"
        onChange={(e) => setSelectedGroupId(e.target.value)}>
        {
          exportableGroups.map((g) => 
            <option key={g.id} value={g.id}>{g.name}</option>
          )
        }
      </select>

      <button type="button" onClick={exportGroup}>Export</button>
    </div>
  )
}

GroupExportTool.propTypes = {
  exportableGroups: PropTypes.arrayOf(PropTypes.shape()).isRequired,
}
export default GroupExportTool;
